import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TodoEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { RadioSelectionGroup, TitledContainerBodyText } from "components/common";
import { ExpandableSection, ExpandableSectionSummary, FormFieldLayout } from "components/common/wintForms";
import { Grid, Typography } from "@mui/material";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

interface PreliminaryTaxUpdateFormContainerProps {
  preliminaryTaxUpdate?: WintSuperkollAPIModel.PreliminaryTaxUpdate;
  selectedResponse: TodoEnums.PreliminaryTaxUpdateResponse | undefined;
  onResponseChange: (action: TodoEnums.PreliminaryTaxUpdateResponse) => void;
  questionText: string;
}

const PreliminaryTaxUpdateFormContainer: React.FC<PreliminaryTaxUpdateFormContainerProps> = ({
  preliminaryTaxUpdate,
  selectedResponse,
  onResponseChange,
  questionText,
}) => {
  const responseChoices = [
    {
      id: TodoEnums.PreliminaryTaxUpdateResponse.Accept,
      value: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Todos.PreliminaryTaxUpdate_Accept),
    },
    {
      id: TodoEnums.PreliminaryTaxUpdateResponse.Decline,
      value: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Todos.PreliminaryTaxUpdate_Decline),
    },
  ];

  return (
    <FormFieldLayout direction="vertical" hideMainLabel>
      <Grid container className={cssExports.sectionedForm} marginBottom={-2.5}>
        <ExpandableSection alwaysOpen>
          <Grid container rowGap={2}>
            <Grid item>
              <Typography className={cssExports.formControlLabel}>{questionText}</Typography>
            </Grid>
            <RadioSelectionGroup
              items={responseChoices}
              value={selectedResponse}
              onChange={(_e, value) => onResponseChange(Number(value))}
            />
          </Grid>
        </ExpandableSection>
        <ExpandableSection
          summary={
            <ExpandableSectionSummary
              title={LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.Todos.PreliminaryTaxUpdate_HowItWorks
              )}
            />
          }
          initiallyOpen={false}
        >
          <TitledContainerBodyText>
            <Grid container direction="column" flexWrap="nowrap" rowGap={2}>
              <Grid item>
                <ul className={cssExports.bodyListItems} style={{ marginTop: 0 }}>
                  <li>
                    {LocalizationHelperInstance.getFormattedMessage(
                      TranslationKeys.Todos.PreliminaryTaxUpdate_HowItWorks_Bullet1,
                      undefined,
                      {
                        date: preliminaryTaxUpdate?.finalTaxDueDate
                          ? DateHelper.formatDate(preliminaryTaxUpdate.finalTaxDueDate)
                          : "",
                      }
                    )}
                  </li>
                  <li>
                    {LocalizationHelperInstance.getFormattedMessage(
                      TranslationKeys.Todos.PreliminaryTaxUpdate_HowItWorks_Bullet2
                    )}
                  </li>
                </ul>
              </Grid>
              <Grid item>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.Todos.PreliminaryTaxUpdate_HowItWorks_Paragraph
                )
                  .split("{deadline}")
                  .map((part, i, arr) =>
                    i < arr.length - 1 ? (
                      <React.Fragment key={i}>
                        {part}
                        <strong>
                          {preliminaryTaxUpdate
                            ? DateHelper.formatDate(
                                DateHelper.addDays(new Date(preliminaryTaxUpdate.submissionDeadline), -1)
                              )
                            : ""}
                        </strong>
                      </React.Fragment>
                    ) : (
                      part
                    )
                  )}
              </Grid>
            </Grid>
          </TitledContainerBodyText>
        </ExpandableSection>
      </Grid>
    </FormFieldLayout>
  );
};

export default PreliminaryTaxUpdateFormContainer;
